jQuery(document).ready(function($) {

	///////////////////////////////////////////////
	// SUBSCRIPTIONS

	// change Title field to custom default value
	const subscriptionTitleField = document.getElementById('_wcsatt_subscription_prompt');

	if (subscriptionTitleField != null) {
		if (subscriptionTitleField.value == '') {
			subscriptionTitleField.value = 'Select frequency';
		}
		// has to be in this order
		updatePeriodSelect();
		updateEmptyDiscountFields();
	}

	$(document).ajaxComplete(function(e) {
		let activeElement = e.currentTarget.activeElement;

		if (activeElement.classList.contains('add_subscription_scheme')) {
			// has to be in this order
			updatePeriodSelect();
			updateEmptyDiscountFields();
		}
	});

	function updateEmptyDiscountFields() {
		let discountFields = document.querySelectorAll('.subscription_pricing_method input');
		
		// set any empty discount fields to default
		if (discountFields != null) {
			discountFields.forEach((discountField) => {
				discountField.value = 10;
			});
		}
	}

	function updatePeriodSelect() {
		let discountFields = document.querySelectorAll('.subscription_pricing_method input');
		
		// see if any discount fields are empty and set that one's period select to "weeks"
		if (discountFields != null) {
			discountFields.forEach((discountField) => {

				if (discountField.value == '') {

					let subscriptionContainer = discountField.closest('.subscription_scheme');

					if (subscriptionContainer != null) {
						
						let periodSelect = subscriptionContainer.querySelector('.wc_input_subscription_period');

						if (periodSelect != null) {
							periodSelect.value = 'week';
						}
					}
				}
			});
		}

	}
});